"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_router_dom_1 = require("react-router-dom");
const common_styled_components_1 = require("../../common-styled-components");
const useFetch_1 = __importDefault(require("../../../hooks/useFetch"));
const apiUtils_1 = require("../../../util/apiUtils");
const ComplianceKPI_1 = __importDefault(require("../common/ComplianceKPI"));
const compliance_1 = require("../../../util/compliance/compliance");
const useMetadata_1 = require("../../../hooks/useMetadata");
const util_1 = require("../util");
const theme_1 = require("../../../theme");
const lodash_1 = require("lodash");
const timeUtils_1 = require("../../../util/timeUtils");
const useFetchAll_1 = __importDefault(require("../../../hooks/useFetchAll"));
const react_1 = require("react");
const MonthlyReportTable_1 = require("../common/tables/MonthlyReportTable");
const TransactionTable_1 = require("../common/tables/TransactionTable");
const YearContext_1 = require("../../../contexts/YearContext");
const enrichShipData = (monthlyReports, ships) => {
    return monthlyReports.filter((d) => d).map((report) => {
        const ship = ships.find((s) => s.id === report?.ship_id);
        return {
            ...report,
            additionalInfo: ship
                ? {
                    shipName: ship.name,
                }
                : undefined,
        };
    });
};
exports.default = () => {
    const { companyId, poolId, year, month } = (0, react_router_dom_1.useParams)();
    const { selectedYear } = (0, YearContext_1.useYear)();
    const [metadata] = (0, useMetadata_1.useMetadata)();
    const params = {
        company_id: Number(companyId),
        pool_id: Number(poolId),
        year: Number(year),
        month: Number(month),
    };
    if ((0, lodash_1.some)((0, lodash_1.values)(params), (v) => isNaN(v))) {
        return ((0, jsx_runtime_1.jsx)(common_styled_components_1.PageContent, { children: "Faulty search params, please return to previous page and try again." }));
    }
    const date = new Date(params.year, params.month - 1, 1);
    const [monthly_report] = (0, useFetch_1.default)("admin/monthly_data.json", JSON.stringify(params));
    const [companies] = (0, useFetch_1.default)("admin/companies.json");
    const [pools] = (0, useFetch_1.default)("admin/pools.json", JSON.stringify({
        pool_id: params.pool_id,
        year: params.year,
    }));
    const [ships] = (0, useFetch_1.default)("admin/ships.json", JSON.stringify({
        company_id: params.company_id,
        pool_id: params.pool_id,
    }));
    const [transactions] = (0, useFetch_1.default)("admin/transactions.json", JSON.stringify({
        pool_id: Number(poolId),
        year: selectedYear,
    }));
    const [ship_reports, _setMonthlyReportsUrl, _setMonthlyReportsBody, setMonthlyReportsVariations,] = (0, useFetchAll_1.default)("admin/monthly_data.json", {
        year: selectedYear,
        month: params.month,
        company_id: params.company_id,
        pool_id: params.pool_id,
    });
    (0, react_1.useEffect)(() => {
        if (ships.status === apiUtils_1.LoaderStatus.Success && ships.data.length) {
            setMonthlyReportsVariations({
                key: "ship_id",
                variations: ships.data.map((s) => s.id),
            });
        }
    }, [ships.status]);
    if (monthly_report.status !== apiUtils_1.LoaderStatus.Success ||
        companies.status !== apiUtils_1.LoaderStatus.Success ||
        pools.status !== apiUtils_1.LoaderStatus.Success ||
        ships.status !== apiUtils_1.LoaderStatus.Success ||
        ship_reports.status !== apiUtils_1.LoaderStatus.Success ||
        transactions.status !== apiUtils_1.LoaderStatus.Success ||
        !metadata) {
        return (0, jsx_runtime_1.jsx)(common_styled_components_1.PageContent, { children: "Loading\u2026" });
    }
    const company = companies.data.find((c) => c.id === params.company_id);
    const pool = pools.data.find((p) => p.id === params.pool_id);
    const monthlyReport = monthly_report.data;
    // find transactions regarding this company's ships and in this month
    const transactionsData = transactions.data
        .filter((d) => ships.data.find((s) => d.from.id === s.id || d.to.id === s.id))
        .filter((d) => {
        const transactionDate = new Date(d.transaction_date);
        return (transactionDate.getFullYear() === params.year &&
            transactionDate.getMonth() + 1 === params.month);
    });
    // log([
    //   {
    //     label: "Report data",
    //     content: monthly_report.data,
    //   },
    //   {
    //     label: "Ship reports",
    //     content: ship_reports.data,
    //   },
    // ]);
    const compliance = (0, compliance_1.getCompliance)(monthlyReport.intensity.adjusted_emission_balance_ton);
    const enrichedShipReports = enrichShipData(ship_reports.data, ships.data);
    return ((0, jsx_runtime_1.jsxs)(common_styled_components_1.PageContent, { align: "left", children: [(0, jsx_runtime_1.jsxs)(common_styled_components_1.ContentGrid, { children: [(0, jsx_runtime_1.jsxs)(common_styled_components_1.GridCard, { children: [(0, jsx_runtime_1.jsxs)(common_styled_components_1.SectionTitle, { children: ["Report for ", (0, timeUtils_1.formatYearMonth)(date)] }), (0, jsx_runtime_1.jsxs)(common_styled_components_1.PTight, { children: [(0, jsx_runtime_1.jsx)(common_styled_components_1.Bold, { children: "Company: " }), company?.name] }), (0, jsx_runtime_1.jsxs)(common_styled_components_1.PTight, { children: [(0, jsx_runtime_1.jsx)(common_styled_components_1.Bold, { children: "Pool: " }), pool?.name] })] }), (0, jsx_runtime_1.jsx)(common_styled_components_1.GridCard, { children: (0, jsx_runtime_1.jsx)(ComplianceKPI_1.default, { compliance: compliance, title: "Carbon intensity", unit: "gCO\u2082e/MJ", value: monthlyReport.intensity.adjusted_intensity_gCO2e_per_MJ }) }), (0, jsx_runtime_1.jsx)(common_styled_components_1.GridCard, { children: (0, jsx_runtime_1.jsx)(ComplianceKPI_1.default, { compliance: compliance, title: "Carbon unit balance", unit: monthlyReport.intensity.adjusted_emission_balance_ton < 0
                                ? "tCO₂e deficit"
                                : "tCO₂e to spare", value: (0, util_1.scaleEmissions)(monthlyReport.intensity.adjusted_emission_balance_ton) }) })] }), (0, jsx_runtime_1.jsxs)(common_styled_components_1.ContentGrid, { "$cols": 1, children: [(0, jsx_runtime_1.jsxs)(common_styled_components_1.GridCard, { children: [(0, jsx_runtime_1.jsx)(common_styled_components_1.SmallSubtitle, { style: {
                                    marginBottom: theme_1.theme.spacing(2),
                                    marginTop: theme_1.theme.spacing(5),
                                }, children: "Ships" }), (0, jsx_runtime_1.jsx)(MonthlyReportTable_1.MonthlyReportTable, { monthlyReports: enrichedShipReports, metadata: metadata, complianceYear: selectedYear, showAdditionalInfo: ["shipName"] })] }), (0, jsx_runtime_1.jsxs)(common_styled_components_1.GridCard, { children: [(0, jsx_runtime_1.jsx)(common_styled_components_1.SmallSubtitle, { style: {
                                    marginBottom: theme_1.theme.spacing(2),
                                    marginTop: theme_1.theme.spacing(4),
                                }, children: "Transactions" }), (0, jsx_runtime_1.jsx)(TransactionTable_1.TransactionTable, { complianceYear: selectedYear, transactions: transactionsData, poolId: pool?.id })] })] })] }));
};
